import { FormField } from '@/components/form-section'
import { MdInfoOutline } from 'react-icons/md'

interface RescheduleReasonFieldProps {
    /** "paciente", "cliente", "tutor"… conforme o segmento. */
    clientLabel: string
    reason: string
    onReasonChange: (value: string) => void
}

/**
 * Aviso e motivo da remarcação.
 *
 * Mudar a data de um atendimento que JÁ tinha data é uma remarcação: o cliente
 * vai ser avisado da nova data e o horário antigo é liberado na agenda. O motivo
 * entra no histórico de remarcações — por isso ele é pedido aqui, e não depois.
 */
export default function RescheduleReasonField({
    clientLabel,
    reason,
    onReasonChange,
}: RescheduleReasonFieldProps) {
    return (
        <div className="flex flex-col gap-3 rounded-xl border border-info/30 bg-info/5 p-4">
            <div className="flex items-start gap-3">
                <MdInfoOutline className="mt-0.5 shrink-0 text-lg text-info" />
                <p className="text-sm leading-relaxed text-base-content/70">
                    Isto é uma <strong>remarcação</strong>. O {clientLabel} será
                    avisado da nova data e o horário anterior será liberado na
                    agenda.
                </p>
            </div>
            <FormField
                label="Motivo da remarcação"
                htmlFor="agendamento-motivo"
            >
                <input
                    id="agendamento-motivo"
                    type="text"
                    className="input input-bordered w-full"
                    placeholder={`Ex.: ${clientLabel} pediu para adiar`}
                    value={reason}
                    onChange={e => onReasonChange(e.target.value)}
                    maxLength={500}
                />
            </FormField>
        </div>
    )
}
